import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/vinted-shipping';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Ultimate Vinted Shipping Guide</title>
        <meta
          name='description'
          content="The seller's cheat sheet on how to ship on Vinted. From who pays for shipping to the shipping options available to sellers and everything there is to know about successfully sending out purchased items to buyers."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/vinted-shipping' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/vinted-shipping' />
        <meta property='og:title' content='The Ultimate Vinted Shipping Guide' />
        <meta
          property='og:description'
          content="The seller's cheat sheet on how to ship on Vinted. From who pays for shipping to the shipping options available to sellers and everything there is to know about successfully sending out purchased items to buyers."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
